import {CommonModule} from '@angular/common';
import {Component, EventEmitter, Input, Output} from '@angular/core';

@Component({
  selector: 'app-marketing-consent-modal',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './marketing-consent-modal.component.html',
  styleUrl: './marketing-consent-modal.component.css'
})
export class MarketingConsentModalComponent {
  @Input() isSaving = false;
  @Input() errorMessage = '';
  @Output() accepted = new EventEmitter<void>();
  @Output() declined = new EventEmitter<void>();
}
